<template>
  <v-layout row wrap white pt-4 pl-3 align-end>
    <v-flex xs2 ml-0 v-show="false">
      <v-menu
        v-model="reportDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            clearable
            v-model="reportDateFormated"
            label="Data inicial"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          type="month"
          no-title
          v-model="formData.date_init"
          @input="reportDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs2 ml-0 pl-3>
      <v-menu
        v-model="reportEndDateMenu"
        :close-on-content-click="true"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            clearable
            v-model="reportEndDateFormated"
            label="Data de referência"
            return-masked-value
            mask="##/####"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          type="month"
          no-title
          v-model="formData.date_end_field"
          @input="reportDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs6 px-3>
      <v-autocomplete
        ref="condominiumCbo"
        clearable
        v-model="formData.condominium_id"
        :items="condominiums"
        item-text="name_fantasy"
        item-value="condominium_id"
        label="Selecione o condomínio"
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template v-if="checkType(data)">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-autocomplete>
    </v-flex>
    <v-flex xs2 pb-3>
      <v-btn color="blue-grey" class="white--text" @click="search">
        Gerar
        <v-icon right dark>cached</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import * as moment from 'moment'
export default {
  data () {
    return {
      reportDateMenu: false,
      reportEndDateMenu: false,
      condominiums: [],
      formData: {
        condominium_id: '',
        date_init: '',
        date_end_field: ''
      }
    }
  },
  computed: {
    reportDateFormated: {
      get () {
        return this.formData.date_init
          ? moment(this.formData.date_init).format('MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          this.formData.date_init = moment(value).format('MM/YYYY')
        } else {
          this.formData.date_init = ''
        }
      }
    },
    reportEndDateFormated: {
      get () {
        return this.formData.date_end_field
          ? moment(this.formData.date_end_field).format('MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 7) return
          console.log(`${value.split('/')[0]}/${value}`)
          this.formData.date_end_field = moment(`${value.split('/')[0]}/${value}`).format(
            'YYYY-MM'
          )
        } else {
          this.formData.date_end_field = ''
        }
      }
    }
  },
  props: {
    filterReport: Function,
    changeTitle: Function
  },
  mounted () {
    this.getComdominiums()
  },
  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },
    changeTitleSelCondominium (id) {
      let txt
      var index = this.condominiums.findIndex(
        condominium => condominium.condominium_id === id
      )

      this.$store.commit('docsReports/updateSearchData', {
        condominiumName: this.condominiums[index].name_fantasy
      })

      txt =
        index > -1
          ? `Condomínio ${this.condominiums[index].name_fantasy}`
          : 'Todos os condomínios'
      this.changeTitle(txt)
    },
    getComdominiums () {
      let obj = {
        url: '/api/get_list',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.condominiums = response.data
        let obj = { condominiums: response.data }
        this.$store.commit('condominiums/updateCondominiumList', obj)
        this.$props.condominiums = response.data
      })
    },
    search () {
      let lastDay = moment(this.formData.date_end_field).daysInMonth()
      this.formData.date_end = this.formData.date_end_field
        ? `${this.formData.date_end_field}-${lastDay}`
        : ''
      this.formData.reportDate = this.reportDateFormated
      this.changeTitleSelCondominium(this.formData.condominium_id)
      this.filterReport(this.formData, this.$refs.condominiumCbo)
    }
  }
}
</script>

<style>
</style>
